<template>
  <el-tag
    v-if="statusMeta"
    :style="{
      backgroundColor: statusMeta.color,
      borderColor: statusMeta.color,
      color: statusMeta.textColor,
      borderRadius: '8px',
    }"
  >
    {{ statusMeta.label }}
  </el-tag>
</template>

<script>
import { resolveHotelOrderStatusMeta } from '../../../enums/statusMap'

export default {
  name: 'HotelOrderStatusTag',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    statusMeta() {
      return resolveHotelOrderStatusMeta(this.status)
    },
  },
}
</script>
